export const FADE_ANIMATION_DELAY = 0.4;
export const BIG_TEXT_ANIMATION_DELAY = 0.1;
